import {
  LuGraduationCap,
  LuSlidersHorizontal,
  LuCalendarClock,
  LuSparkles,
  LuHeadphones,
  LuGlobe,
} from 'react-icons/lu'

export const WHY_CHOOSE_US_CONTENT = {
  eyebrow: 'WHY CHOOSE US?',
  title: 'A Quran Learning Experience',
  highlight: 'Built Around You',
  description:
    'We combine authentic Islamic education with personalized learning and modern technology to help every student grow with confidence.',
}

export const WHY_CHOOSE_US_REASONS = [
  {
    title: 'Qualified & Ijazah-Holding Teachers',
    description:
      'Learn from qualified teachers with strong Quranic backgrounds and verified Ijazah, dedicated to helping students recite and learn correctly.',
    icon: LuGraduationCap,
  },
  {
    title: 'Personalized Learning Plans',
    description:
      'Every student is different. We tailor lessons according to age, level, pace, goals, and previous knowledge.',
    icon: LuSlidersHorizontal,
  },
  {
    title: 'Flexible Global Scheduling',
    description:
      'Learn at a time that works for you. With flexible scheduling across different time zones, Quran learning fits naturally into your routine.',
    icon: LuCalendarClock,
  },
  {
    title: 'Free Trial Classes',
    description:
      'Experience the learning journey before you commit. Meet your teacher, explore our teaching approach, and discover the right path for you.',
    icon: LuSparkles,
  },
  {
    title: 'Dedicated Student Support',
    description:
      "You're never alone on your learning journey. Our team is here to assist with scheduling, questions, feedback, and ongoing support.",
    icon: LuHeadphones,
  },
  {
    title: 'A Growing Global Community',
    description:
      'Join students from around the world and become part of a community united by the love of the Quran.',
    icon: LuGlobe,
  },
]
